import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';

const App = lazy(() => import('./App'));

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <Suspense fallback={<div className="loading" />}>
            <App />
        </Suspense>
    </Provider>
);